import { type Vector3 } from 'three';

export const linePoint = (a: Vector3, b: Vector3, length: number) => {
    const dir = b.clone().sub(a).normalize().multiplyScalar(length);
    return a.clone().add(dir);
};
